import { gql } from "@apollo/client";

export const ADD_POLE = gql`
  mutation AddPole($data: PoleDataInput) {
    addPole(data: $data) {
      id
    }
  }
`;

export const DELETE_POLE = gql`
  mutation DeletePole($where: PoleWhereInput) {
    deletePole(where: $where) {
      id
    }
  }
`;

const poles = { ADD_POLE, DELETE_POLE };

export default poles;
